import { TbArrowNarrowRight } from 'react-icons/tb'
import {
  GradientBars,
  GradientPresentation,
} from '~/components/illustration/gradient-icons'

export const LearnMoreSection = ({
  title,
  subTitle,
}: {
  title?: string
  subTitle?: string
}) => {
  return (
    <section className="wide">
      <hgroup className="centered-section-title">
        <h3>{title}</h3>
        <h4>{subTitle}</h4>
      </hgroup>

      <div className="grid cols2 call-out-cards">
        <div>
          <GradientBars />
          <h4>Business intelligence</h4>
          <ul>
            <li>Explore data easily</li>
            <li>Build beautiful visualizations</li>
            <li>Rapidly share findings</li>
          </ul>

          <a href="/business-intelligence" className="arrow-link">
            <span>Learn more</span> <TbArrowNarrowRight />
          </a>
        </div>
        <div>
          <GradientPresentation />
          <h4>Embedded analytics</h4>
          <ul>
            <li>Speed up product development</li>
            <li>Increase customer engagement</li>
            <li>Monetize your data</li>
          </ul>
          <a href="/embedded-analytics" className="arrow-link">
            <span>Learn more</span> <TbArrowNarrowRight />
          </a>
        </div>
      </div>
    </section>
  )
}
